export default __webpack_public_path__ + "static/media/mw_wheel_border.350e5eca.gif";